module.exports = __webpack_public_path__ + "img/thumbnail_pillar.84cc969f.png";